/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { AdminPointPolicyDto, AdminPointPolicyRequestDto } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class AdminPointPolicyService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags AdminPointPolicyService
   * @name GetPointPolicy
   * @summary Get Point Policy
   * @request GET:/v1/admin/point-policy
   * @secure
   */
  getPointPolicy = (params: RequestParams = {}) =>
    this.http.request<AdminPointPolicyDto, any>({
      path: `/v1/admin/point-policy`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminPointPolicyService
   * @name SavePointPolicy
   * @summary Save Point Policy
   * @request POST:/v1/admin/point-policy
   * @secure
   */
  savePointPolicy = (data: AdminPointPolicyRequestDto, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/point-policy`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
